module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-9.78a20ac4.png";